import { type FC } from "react";
import { useNavigate, useSearchParams } from "react-router";

import { useMutation, useQuery } from "@apollo/client/react";

import {
  DashboardProjectsDetailsDocument,
  ProjectChangeDocument,
  type ProjectInput,
} from "@app_schema";

import { useRequiredParam } from "@application/hooks/use_required_param";

import { DashboardProjectsForm } from "./projects_form";

export const DashboardProjectsEdit: FC = () => {
  const id = useRequiredParam("id");
  const navigate = useNavigate();
  // `?section=` sends Save back to the tab that linked here.
  const [searchParams] = useSearchParams();
  const section = searchParams.get("section");
  const { data: defaults } = useQuery(DashboardProjectsDetailsDocument, {
    variables: { id },
  });
  const [execute, { loading, data }] = useMutation(ProjectChangeDocument);
  const errors = data?.project.change.errors;

  const save = async (input: ProjectInput) => {
    const result = await execute({ variables: { id, input } });
    const project = result.data?.project.change.project;
    if (!project) return;

    navigate(
      section
        ? `/dashboard/projects/${project.id}?section=${encodeURIComponent(section)}`
        : `/dashboard/projects/${project.id}`,
    );
  };

  if (!defaults) return;
  const project = defaults.project;

  return (
    <DashboardProjectsForm
      save={save}
      errors={errors}
      loading={loading}
      project={project}
    />
  );
};
